import React from 'react'
import './Tranjection.css'

const Tranjection = ({paymentId, clientId, label, paymentStatus, purchaseId, ammount, isPaid }) => {
    return (
        <div className={isPaid ? 'payment' : 'unpaid-payment'}>
            <h4 style={{fontSize: `16px`}}>{paymentId}</h4>
            <p>{label}: {clientId}</p>
            <p>Status: {paymentStatus}</p>
            <p>Purchase ID: {purchaseId}</p>
            <p>${ammount}</p>
        </div>
    )
}

export default Tranjection
